import { InitialSetupState } from "../models/model";
import { InitialSetupActions } from "../interface/reducerType";

const initialState = {
  initialMenu: [],
  percentage: "",
  completedMenu: {},
  selectedMenu: "",
  isEdit: false,
  editData: {},
  create: false,
  editDataName: "",
  isOpenAudioPlayer: false,
  audioPlayerData: {},
  playerName: "",
  doPause: false,
  doPlay: false,
  queueList: [],
  userList: [],
  userUpdate: false,
  businessHoursList: [],
  businessHoursConstant: [],
  isUpdate: false,
  contactNumberList: [],
  isUpdated: false,
  routingListTableData: [],
  routingListConstantData: [],
  promptLibraryData: [],
  agentstatusList: [],
  agentstatusdata: [],
  skillmanagementList: [],
  customTagList: [],
  customTagListConst: [],
  isUpdateCustome: false,
  didList: [],
  EnableQueueList: [],
  enableSkillmanagementList: [],
  routingProfileEnableList: [],
  contactList1: [],
  contactConstant: [],
  webChatList: [],
  quickActnData: [],
  quickActnEditData: {},
  isQuickActnEdit: false,
  isTemplateBot: false,
  templateName: "",
  templateBot: {},
  maxWaitTime: 0

  // editQuickActnData : {}
};
export const initialSetupReducer = (
  state: InitialSetupState = initialState,
  action: InitialSetupActions
) => {
  switch (action.type) {
    case "INITIAL_MENU":
      return {
        ...state,
        initialMenu: action.payload.initialMenu,
        percentage: action.payload.percentage,
        completedMenu: action.payload.completedMenu,
        selectedMenu: action.payload.selectedMenu,
      };
    case "CUSTOMER_TAG_DATA":
      return {
        ...state,
        customTagList: action.payload.customTagList,
        isUpdateCustome: action.payload.isUpdateCustome,
        customTagListConst: action.payload.customTagListConst,
      };
    case "SETUP_EDIT":
      return {
        ...state,
        isEdit: action.payload.isEdit,
        editData: action.payload.editData,
        editDataName: action.payload.editDataName,
      };
    case "SETUP_CREATE":
      return {
        ...state,
        create: action.payload.create,
      };
    case "DO_OPEN_AUDIO_PLAYER":
      return {
        ...state,
        isOpenAudioPlayer: action.payload.isOpenAudioPlayer,
        audioPlayerData: action.payload.audioPlayerData,
        playerName: action.payload.playerName,
        doPause: action.payload.doPause,
        doPlay: action.payload.doPlay,
      };
    case "BUSINESS_HOURS":
      return {
        ...state,
        businessHoursList: action.payload.businessHoursList,
        businessHoursConstant: action.payload.businessHoursConstant,
      };
    case "ROUTING_PROFILE_DATA":
      return {
        ...state,
        routingListTableData: action.payload.routingListTableData,
        routingListConstantData: action.payload.routingListConstantData,
      };
    case "CONTACT_CENTRE_NUMBER":
      return {
        ...state,
        contactNumberList: action.payload.contactNumberList,
        isUpdated: action.payload.isUpdated,
        didList: action.payload.didList,
      };

    case "CONTACTS":
      return {
        ...state,
        contactList1: action.payload.contactList1,
        contactConstant: action.payload.contactConstant,
      };
    // case "ROUTING_PROFILE_DATA":
    //   return {
    //     ...state,
    //     routingListTableData: action.payload.routingListTableData,
    //     routingListConstantData: action.payload.routingListConstantData,
    //   };
    // case "CONTACT_CENTRE_NUMBER":
    // return {
    //   ...state,
    //   contactNumberList: action.payload.contactNumberList,
    //   isUpdated: action.payload.isUpdated,
    //   didList: action.payload.didList,
    // };

    case "USER_MANAGEMENT":
      return {
        ...state,
        userList: action.payload.userList,
        userUpdate: action.payload.userUpdate,
      };
    case "AGENT_STATUS":
      return {
        ...state,
        agentstatusList: action.payload.agentstatusList,
        agentstatusdata: action.payload.agentstatusdata,
      };
    case "PROMPT_LIBRARY_DATA":
      return {
        ...state,
        promptLibraryData: action.payload.promptLibraryData,
      };
    case "SKILL_MANAGEMENT":
      return {
        ...state,
        skillmanagementList: action.payload.skillmanagementList,
      };
    case "QUEUE_LIST":
      return { ...state, queueList: action.payload.queueList };
    case "QUEUE_LIST_ENABLE":
      return { ...state, EnableQueueList: action.payload.EnableQueueList };
    case "SKILL_MANAGEMENT_ENABLE":
      return {
        ...state,
        enableSkillmanagementList: action.payload.enableSkillmanagementList,
      };
    case "ROUTING_PROFILE_ENABLE":
      return {
        ...state,
        routingProfileEnableList: action.payload.routingProfileEnableList,
      };
    case "WEB_CHAT_LIST":
      return { ...state, webChatList: action.payload.webChatList };

    default:
      return state;
  }
};
